module.exports = __webpack_public_path__ + "static/media/icon-shorttime-garage.9e4a443a.svg";